//  Warning For Samsung Internet Darkmode 
 document.addEventListener("DOMContentLoaded", function() {
    if (navigator.userAgent.match(/samsung/i)) {
        alert("Your browser (Samsung Internet) might not be showing you this " + 
              "website correctly. Please use a standards-compliant browser" +
              "instead. \n\n" + "We recommend Firefox, Microsoft Edge, " + 
              "or Google Chrome.");
    }
  }
)

// Detect "Sale" in Header Menu (matches anything with "sale")
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".has-submenu .menu-link").forEach(link => {
    const text = link.textContent.trim().toLowerCase();

    if (text.includes("sale")) {
      link.classList.add("highlight-sale");

      if (link.closest("li")) {
        link.closest("li").classList.add("highlight-sale-item");
      }
    }
  });
});

// Change Countdown Time Unit
document.addEventListener("DOMContentLoaded", () => {
  const replacements = {
    "Days": "d",
    "วัน": "d",
    "Hrs": "h",
    "ชั่วโมง": "h",
    "Min": "m",
    "นาที": "m",
    "Sec": "s",
    "วินาที": "s",
  };

  document.querySelectorAll(".time-helper.text-size--small").forEach(el => {
    const text = el.textContent.trim();
    if (replacements[text]) {
      el.textContent = replacements[text];
    }
  });
});


// Add copy Code Button
document.addEventListener("DOMContentLoaded", function() {
  // Detect current language
  const lang = document.documentElement.lang || "en";
  const isThai = lang.startsWith("th");

  // Define language-specific text
  const buttonText = isThai ? "คัดลอกโค้ด" : "Copy";
  const copiedText = isThai ? "คัดลอกแล้ว ✅" : "Copied ✅";

  // Target the section
  const section = document.querySelector("#shopify-section-template--18317049987248__text_columns_jyRhBQ");
  if (!section) return;

  // Loop through each card
  section.querySelectorAll(".js-slider-item").forEach((card) => {
    const btn = document.createElement("button");
    btn.textContent = buttonText;
    btn.className = "button button--regular button--solid copy-link-btn";

    btn.addEventListener("click", function() {
      // Find the <p> that contains the code text (depends on language)
      const codeParagraph = Array.from(card.querySelectorAll("p"))
        .find(p => /กรอกโค้ด:|code:/i.test(p.textContent));

      let code = "";
      if (codeParagraph) {
        // Remove the prefix (กรอกโค้ด: or Code:) and trim spaces
        code = codeParagraph.textContent.replace(/(กรอกโค้ด:|code:)/i, "").trim();
      }

      if (code) {
        navigator.clipboard.writeText(code).then(() => {
          btn.textContent = copiedText;
          setTimeout(() => {
            btn.textContent = buttonText;
          }, 2000);
        });
      }
    });

    // Append button inside .increased-spacing
    let btnWrapper = card.querySelector(".increased-spacing");
    if (!btnWrapper) {
      btnWrapper = document.createElement("div");
      btnWrapper.className = "increased-spacing";
      card.appendChild(btnWrapper);
    }

    btnWrapper.appendChild(btn);
  });
});



// Change Product Page review Text
document.addEventListener("DOMContentLoaded", function () {
  const targetSelector = ".jdgm-prev-badge__text";

  function updateReviewText(el) {
    if (!el) return;

    const text = el.textContent.trim();

    // Match: "1 review", "5 reviews", "1 รีวิว", "5 รีวิว"
    const match = text.match(/^(\d+)\s*(reviews?|รีวิว)$/i);

    if (match) {
      el.textContent = `(${match[1]})`;
    }
  }

  // Run once at page load
  document.querySelectorAll(targetSelector).forEach(updateReviewText);

  // Observe for changes (in case Judge.me loads async)
  const observer = new MutationObserver(() => {
    document.querySelectorAll(targetSelector).forEach(updateReviewText);
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

// Inject Footer Text
document.addEventListener("DOMContentLoaded", function() {
  const footer = document.querySelector(".footer-bottom .container--large");

  if (footer) {
    const credit = document.createElement("a");
    credit.href = "https://plaimanas.com"; 
    credit.target = "_blank";
    credit.rel = "noopener";
    credit.textContent = "Web by ::*";
    credit.className = "plaimanas-credit";

    const copyright = footer.querySelector("span");
    if (copyright) {
      copyright.appendChild(document.createTextNode(" "));
      copyright.appendChild(credit);
    } else {
      footer.appendChild(credit);
    }
  }
});

// Product Accordion
document.addEventListener("DOMContentLoaded", function() {
  const productAccordion = document.querySelector(".product-text .product-actions + .card-widget.card-widget--no-padding");
  if (!productAccordion) return;

  const accordionTitle = productAccordion.querySelector(".card-widget__header-text__title");
  const accordionContent = productAccordion.querySelector(".card-widget__content");

  if (!accordionContent) return;

  productAccordion.classList.add("is-open");

  accordionTitle.addEventListener("click", function() {
    productAccordion.classList.toggle("is-open");
  });
});

// FIX: Lang TH Review Modal
document.addEventListener("DOMContentLoaded", () => {
  // Run only if page language is Thai
  if (document.documentElement.lang !== "th") return;

  const observer = new MutationObserver(() => {
    const titleEl = document.querySelector(".jdgm-write-review-modal__title");
    if (titleEl && titleEl.textContent.includes(" {{ product_title }}")) {
      titleEl.innerHTML = titleEl.innerHTML.replace(" {{ product_title }}", "สินค้านี้");
      observer.disconnect(); // Stop observing after success
    }
  });

  // Observe the whole body for modal insertion
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
});